import type { ComponentProps, JSX } from 'solid-js'
import { splitProps } from 'solid-js'

/** Optional refs/styles for the container so callers can attach a
 *  ResizeObserver / max-height for the standard scrollable-table layout
 *  (see `lib/useScrollableTable`). */
type RootProps = ComponentProps<'table'> & {
  containerRef?: (el: HTMLDivElement) => void
  containerClass?: string
  containerStyle?: JSX.CSSProperties
}
const Root = (props: RootProps) => {
  const [own, rest] = splitProps(props, ['containerRef', 'containerClass', 'containerStyle', 'class'])
  return (
    <div
      ref={own.containerRef}
      class={
        'rounded-lg border border-border ' +
        (own.containerClass ?? 'overflow-x-auto')
      }
      style={own.containerStyle}
    >
      <table class={'w-full text-sm ' + (own.class ?? '')} {...rest} />
    </div>
  )
}
const Header = (props: ComponentProps<'thead'>) => (
  <thead class={'bg-surface-alt text-xs uppercase tracking-wide text-muted ' + (props.class ?? '')} {...props} />
)
const Body = (props: ComponentProps<'tbody'>) => <tbody {...props} />
const Row = (props: ComponentProps<'tr'> & { interactive?: boolean }) => {
  const [l, rest] = splitProps(props, ['interactive', 'class'])
  return <tr class={'border-t border-border h-row ' + (l.interactive ? 'hover:bg-surface-alt cursor-pointer ' : '') + (l.class ?? '')} {...rest} />
}
const Cell = (props: ComponentProps<'td'>) => <td class={'px-4 align-middle ' + (props.class ?? '')} {...props} />
const HCell = (props: ComponentProps<'th'>) => <th class={'px-4 text-left font-semibold ' + (props.class ?? '')} {...props} />

export const Table = Object.assign(Root, { Header, Body, Row, Cell, HCell })
